import { themes } from '@/config/theme'; // Returns the theme name by theme id

export function getThemeName(themeId) {
  var _themes$find;

  return ((_themes$find = themes.find(theme => theme.id === themeId)) === null || _themes$find === void 0 ? void 0 : _themes$find.name) || '';
}